import { SHA256 } from "crypto-js";

import normalizeText from "./normalizeText";

// Matches list item prefixes at the start of a line, including:
// - Bullets: "- ", "* ", "• "
// - Numbered/lettered: "1. ", "A. ", "a. ", "1) ", "a) "
// - Parenthesized: "(1) ", "(A) ", "(1.2) "
// - Hierarchical numbering: "1.1 ", "A.B.C "
// - Roman numerals: "i. ", "iv. ", "XIV. "
export const LIST_ITEM_PREFIX_REGEX =
  /^\s*(?:\([A-Za-z0-9]+(?:\.[A-Za-z0-9]+)*\)|[A-Za-z0-9]+\.[A-Za-z0-9]+(?:\.[A-Za-z0-9]+)*|[A-Za-z0-9]+\.|[A-Za-z0-9]+\)|[ivxlcdmIVXLCDM]+\.|[-*•])\s+/;

const createHashFromText = (str = "") => {
  const textWithNoListPrefixes = str.trim().replace(LIST_ITEM_PREFIX_REGEX, "");
  const normalized = normalizeText(textWithNoListPrefixes);

  return SHA256(normalized).toString();
};

export default createHashFromText;
